import { AddUserView } from '@/domains/users/components/AddUserView';
import { useNavigate } from 'react-router';

export function AddUserPage() {
  const navigate = useNavigate();

  return <AddUserView onBack={() => navigate('/users')} onUserCreated={() => navigate('/users')} />;
}
